<template>
  <div class="login">
    <router-view></router-view>
  </div>
</template>

<script>
    export default {
      data (){
        return {}
      },
      methods: {
          //操作按钮事件
      },
    created: function(){
      var that = this;
      if(that.IsPC()){
        window.location.href = API.IsPcName
      }
      if (!passport.isLoginedStatus()) {
        console.log('判断是否登录-未登录')
      }else{
        that.$http.get(API.GetCountByUserid)
          .then(function (res) {
            if (res.code == 0) {
                that.$router.push({name: 'MyMessage'})
            }
          })
      }
    },
      mounted: function () {
          //操作DOM

      }

    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/login.vue